import Output from '../Output';
import Color  from '../../../../Lib/Color';

export default class ColorPreview extends Output {

    static default = true;
    static type = 'line';
    static label = 'Color Preview';

    output() {
        let color = Color.ensureColor(this.subject.color);

        return `<span class="swatch-color" style="background-color: ${color.hex().value}"></span> ${this.decorator.output()}`;
    }

}